/**
 * Shared sports place-bet payload builder
 * Aligns with the same API contract used by the shared (Diamond) project
 * so the backend receives a consistent payload from both apps.
 */

/**
 * Map our market shorthand to backend game_type
 * MO -> MATCH (MATCH_ODDS), BM -> BOOKMAKER, FAN -> FANCY
 */
const MARKET_TO_GAME_TYPE = {
  MO: 'MATCH',
  BM: 'BOOKMAKER',
  FAN: 'FANCY',
};

/**
 * Build the place-bet payload in shared format
 * @param {Object} bet - Bet row: matchId, matchTitle, team1, team2, selectionName, type, odds, stake, market, marketName, eventid, and optional sid, marketId, runners, matchStartTime
 * @param {string} userId - Logged-in user id (uid)
 * @returns {Object} Payload for POST /sportsbetting/place
 */
export function buildSharedPlacePayload(bet, userId) {
  const safeBet = { market: 'MO', ...bet };
  const matchTitle = safeBet.matchTitle || '';
  const parts = matchTitle.split(' v ');
  const teamOne = safeBet.team1 || parts[0]?.trim() || '';
  const teamTwo = safeBet.team2 || parts[1]?.trim() || '';
  const gameType = MARKET_TO_GAME_TYPE[safeBet.market] || 'MATCH';
  const marketId = safeBet.marketId || safeBet.matchId;
  const eventId = safeBet.eventid || safeBet.matchId;

  const payload = {
    user_id: userId,
    event_id: String(eventId ?? ''),
    match_id: String(safeBet.matchId ?? ''),
    market_id: String(marketId ?? safeBet.matchId ?? ''),
    match_title: matchTitle,
    match_start_time: safeBet.matchStartTime || new Date().toISOString(),
    market_name: safeBet.marketName || 'Match Odds',
    market_type: safeBet.marketName || 'MATCH_ODDS',
    game_type: gameType,
    fancy_name: gameType === 'FANCY' ? 'FANCY' : '',
    team_one: teamOne,
    team_two: teamTwo,
    sid: safeBet.sid != null ? String(safeBet.sid) : '',
    team: safeBet.selectionName || '',
    selection_name: safeBet.selectionName || '',
    bet_type: safeBet.type || 'back',
    odds: Number(safeBet.odds) || 0,
    stake_amount: Number(safeBet.stake) || 0,
    original_currency: 'INR',
    original_amount: Number(safeBet.stake) || 0,
    category: 1,
    count: safeBet.count || 1,
    eventid: safeBet.eventid || eventId,
    marketname: safeBet.marketName || 'Match Odds',
  };

  if (safeBet.runners && Array.isArray(safeBet.runners)) {
    payload.runners = safeBet.runners;
  }
  if (safeBet.rawBackSize != null) payload.rawBackSize = Number(safeBet.rawBackSize);
  if (safeBet.rawLaySize != null) payload.rawLaySize = Number(safeBet.rawLaySize);
  if (safeBet.mname != null) payload.mname = safeBet.mname;
  if (safeBet.gtype != null) payload.gtype = safeBet.gtype;
  if (safeBet.section != null && Array.isArray(safeBet.section)) payload.section = safeBet.section;
  if (safeBet.nat != null) payload.nat = safeBet.nat;

  const usdAmount = (Number(safeBet.stake) || 0) / 83;
  payload.usd_amount = Math.round(usdAmount * 100) / 100;

  return payload;
}
